export type TipoCenario =
  | 'QUEBRA'
  | 'SEGURO'
  | 'ADIANTAMENTO'
  | 'MARGEM_MINIMA'
  | 'PEDAGIO_CLIENTE'
  | 'PEDAGIO_BASE_CALCULO'
  | 'COBRANCA_PEDAGIO'
  | 'DESCONTA_ICMS_FATURA'
  | 'TRUNCA_ICMS'
  | 'CLASSIFICACAO'
  | 'GMP_PLUS'
  | 'CONFIGURACAO'

export type TipoCondicaoCenario =
  | 'GRUPO_NEGOCIADOR'
  | 'TOMADOR'
  | 'REMETENTE'
  | 'DESTINATARIO'
  | 'LOCAL_COLETA'
  | 'LOCAL_ENTREGA'
  | 'FILIAL_EMISSAO'
  | 'AGRUPADOR_PRODUTO'
  | 'PRODUTO'
  | 'UNIDADE_NEGOCIO'
  | 'CENTRO_CUSTO'
  | 'UF_ORIGEM'
  | 'UF_DESTINO'
  | 'CIDADE_ORIGEM'
  | 'CIDADE_DESTINO'
  | 'ESPECIE'
  | 'TIPO_LOTE'
  | 'CLASSIFICACAO_FRETE'

export interface CenarioCondicao {
  id?: string
  tipo: TipoCondicaoCenario | ''
  valorId?: string
  valorTexto?: string
  rotulo?: string
}

export interface CenarioValorItem {
  id?: string
  chave: string
  valor: string
}

export interface Cenario {
  id?: string
  tipo: TipoCenario | ''
  descricao: string
  dataInicio: string
  dataFim?: string | null
  ativo: boolean
  condicoes: CenarioCondicao[]
  valores: CenarioValorItem[]
}

export interface CenarioDetail extends Cenario {
  id: string
  codigo: number
}

export interface AlterarSituacaoData {
  ativo: boolean
}

// -------- GET /cenarios/metadata --------

export type DominioNumero = { tipo: 'numero'; min?: number; max?: number }
export type DominioCodigo = { tipo: 'codigo'; valores: Record<string, string> }
export type DominioBooleanoSN = { tipo: 'booleano-sn' }
export type DominioTexto = { tipo: 'texto' }
export type Dominio =
  | DominioNumero
  | DominioCodigo
  | DominioBooleanoSN
  | DominioTexto

export interface ChaveValorMetadata {
  chave: string
  label: string
  obrigatorio: boolean
  dominio: Dominio
}

export interface CenarioTipoMetadata {
  label: string
  chaves: ChaveValorMetadata[]
}

export interface CondicaoMetadata {
  label: string
  isEntidade: boolean
  valoresFixos?: string[]
  resourceUrl?: string
  labelField?: string
  paramSearch?: string
}

export interface CenarioMetadataResponse {
  tipos: Record<TipoCenario, CenarioTipoMetadata>
  condicoes: Record<TipoCondicaoCenario, CondicaoMetadata>
}

export const situacaoFiltroOptions = [
  { value: 'true', label: 'Ativo' },
  { value: 'false', label: 'Inativo' }
]
